import { Eye, FileText, Loader2 } from 'lucide-react';
import { Barre, Section, TEINTES } from './constantes';
import { BadgeAcces, Filtres, nomComplet, useFiltres, useSuivi, wordStagiaire } from './suiviCommun';

const Avancement = ({ c, couleur, testId }) => (
  <div className="min-w-[120px]" data-testid={testId}>
    <p className="text-xs font-semibold text-[#0F172A]">{c.pret}/{c.total} prêts <span className="font-normal text-slate-400">· {c.en_cours} en cours</span></p>
    <Barre pret={c.pret} total={c.total} couleur={couleur} className="mt-1" />
  </div>
);

const Ligne = ({ s, onVoir }) => (
  <tr className="border-t border-slate-100" data-testid={`guide-suivi-ligne-${s.user_id}`}>
    <td className="px-3 py-3 font-semibold text-[#0F172A]">{nomComplet(s)}</td>
    <td className="px-3 py-3 text-slate-600">{s.session || '—'}</td>
    <td className="px-3 py-3"><BadgeAcces ok={s.acces} testId={`guide-suivi-acces-${s.user_id}`} /></td>
    <td className="px-3 py-3"><Avancement c={s.blocs.BC1} couleur={TEINTES.teal.barre} testId={`guide-suivi-bc1-${s.user_id}`} /></td>
    <td className="px-3 py-3"><Avancement c={s.blocs.BC2} couleur={TEINTES.coral.barre} testId={`guide-suivi-bc2-${s.user_id}`} /></td>
    <td className="px-3 py-3 text-xs text-slate-500">{s.maj_le ? new Date(s.maj_le).toLocaleDateString('fr-FR') : 'Jamais ouvert'}</td>
    <td className="px-3 py-3">
      <div className="flex flex-wrap gap-1.5">
        <button type="button" onClick={() => onVoir(s)} data-testid={`guide-suivi-voir-${s.user_id}`}
          className="inline-flex items-center gap-1 rounded-lg bg-[#0F172A] px-2.5 py-1.5 text-xs font-semibold text-white transition-colors hover:bg-[#1E293B]"><Eye className="h-3.5 w-3.5" /> Voir</button>
        {['BC1', 'BC2'].map((b) => (
          <button key={b} type="button" onClick={() => wordStagiaire(s, b)} data-testid={`guide-suivi-word-${b}-${s.user_id}`}
            className="inline-flex items-center gap-1 rounded-lg border border-slate-200 px-2.5 py-1.5 text-xs font-semibold text-slate-700 transition-colors hover:bg-slate-50"><FileText className="h-3.5 w-3.5" /> {b}</button>
        ))}
      </div>
    </td>
  </tr>
);

export const SuiviGuide = ({ onVoir }) => {
  const { data } = useSuivi();
  const f = useFiltres(data?.stagiaires);
  return (
    <Section titre="Suivi des stagiaires" sousTitre="Progression de chaque stagiaire dans le guide, en lecture seule. « Voir » ouvre son guide avec ses notes." testId="guide-suivi">
      {!data ? <Loader2 className="mx-auto h-6 w-6 animate-spin text-slate-400" /> : (
        <div className="space-y-4">
          <Filtres f={f} sessions={data.sessions} prefixe="guide-suivi" />
          <div className="overflow-x-auto rounded-xl border border-slate-200">
            <table className="w-full min-w-[820px] text-left text-sm">
              <thead className="bg-slate-50 text-xs uppercase tracking-wide text-slate-500">
                <tr>{['Stagiaire', 'Session', 'Accès', 'BC1', 'BC2', 'Mis à jour', ''].map((c) => <th key={c} className="px-3 py-2.5 font-semibold">{c}</th>)}</tr>
              </thead>
              <tbody>{f.liste.map((s) => <Ligne key={s.user_id} s={s} onVoir={onVoir} />)}</tbody>
            </table>
            {!f.liste.length && <p className="p-6 text-center text-sm text-slate-400" data-testid="guide-suivi-vide">Aucun stagiaire</p>}
          </div>
        </div>
      )}
    </Section>
  );
};
